import type { ApiSearchQuery } from '@/lib/api/api-type-helper';

import { ALL_TASK_TAB } from '../-constants';

type ApprovalTaskApiStatus = NonNullable<
  ApiSearchQuery<'/v2/self-service/approval-tasks', 'get'>['status']
>;

const approvalTaskStatusTabs = {
  PENDING_APPROVAL: 'PendingApproval',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  RETURNED: 'Returned',
} as const satisfies Record<string, ApprovalTaskApiStatus>;

export const ApprovalTaskTab = {
  ...approvalTaskStatusTabs,
  ALL: ALL_TASK_TAB,
} as const;

export type ApprovalTaskTab =
  (typeof ApprovalTaskTab)[keyof typeof ApprovalTaskTab];

export function toApprovalTaskApiStatus(
  tab?: ApprovalTaskTab,
): ApprovalTaskApiStatus | undefined {
  if (!tab || tab === ApprovalTaskTab.ALL) {
    return undefined;
  }
  return tab;
}
